module.exports = __webpack_public_path__ + "img/image02.4ce80f04.jpg";